import React, { useEffect, useState } from "react";
import { Table, Button, Space } from "antd";
import { getDirectusClient } from "../../lib/directus";
import { readItems, deleteItem } from "@directus/sdk";
import AddDescuento from "./components/AddDescuento";
import EditDescuento from "./components/EditDescuento";
import Layouts from "../../components/Layouts";

function Descuentos() {
  const [descuentos, setDescuentos] = useState([]);
  const [openadd, setOpenadd] = useState(false);
  const [openedit, setOpenedit] = useState(false);
  const [descuentoSelect, setDescuentoSelect] = useState(null);


  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Descuento",
      dataIndex: "descuento",
      key: "descuento",
      render: (text) => Number(text).toFixed(5),
    },
    {
      title: "Usuarios",
      key: "usuarios",
      render: (_, record) => {
        if (!record.usuarios || !Array.isArray(record.usuarios)) {
          return "N/A";
        }
        return record.usuarios
          .filter(u => u.directus_users_id)
          .map(u => u.directus_users_id.first_name)
          .join(", ");
      }
    },
    {
      title: "Productos",
      key: "productos",
      render: (_, record) => {
        if (!record.productos) return "N/A";
        // Handle both array and single object cases
        const productos = Array.isArray(record.productos) 
          ? record.productos 
          : [record.productos];
        return productos
          .map(p => p.nombre)
          .join(", ");
      }
    },
    {
      title: "Acciones",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button type="primary" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Button type="primary" danger onClick={() => handleDelete(record)}>
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const getDescuentos = async () => {
    const directus = await getDirectusClient();
    try {
      const res = await directus.request(
        readItems("descuentos", {
          fields: [
            "id",
            "nombre",
            "descuento",
            "usuarios.directus_users_id.id",
            "usuarios.directus_users_id.first_name",
            "usuarios.directus_users_id.last_name",
            "productos.id",
            "productos.nombre",
            "productos.referencia",
            "productos.grupo.*"
          ],
        })
      );
      
      setDescuentos(res);
    } catch (err) {
      console.error("Error loading descuentos:", err);
    }
  };

  const handleDelete = async (record) => {
    const directus = await getDirectusClient();
    directus
      .request(deleteItem("descuentos", record.id))
      .then(() => {
        getDescuentos();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleEdit = (record) => {
    setDescuentoSelect(record);
    setOpenedit(true);
  };

  const addModal = () => {
    setOpenadd(!openadd);
  };

  const editModal = () => {
    setOpenedit(!openedit);
    setDescuentoSelect(null);
  };

  useEffect(() => {
    getDescuentos();
  }, []);

  return (
    <Layouts>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={addModal}>
          Agregar Descuento
        </Button>
      </div>

      <Table columns={columns} dataSource={descuentos} />

      <AddDescuento
        openadd={openadd}
        addModal={addModal}
        getDescuentos={getDescuentos}
      />

      {descuentoSelect && (
        <EditDescuento
          openedit={openedit}
          editModal={editModal}
          getDescuentos={getDescuentos}
          descuentoSelect={descuentoSelect}
        />
      )}
    </Layouts>
  );
}

export default Descuentos;
